const { FIREBASE_ENV = 'production' } = process.env;
const IS_PROD = FIREBASE_ENV === 'production';

const CDN_CONFIG = {
  hosting: {
    origin: 'https://sayido.do/static/',
    cdn: 'https://sayido-cdn-production.b-cdn.net/static/', // TODO: Support environment. E.g.: FIREBASE_ENV === 'production' ? 'https://sayido-cdn-production.b-cdn.net' : 'https://sayido-cdn-development.b-cdn.net/';
  },
  ugc: {
    origin: 'https://uploads.sayi.do/',
    cdn: 'https://bcdn-2738.sayido.app/',
  },
  assets: {
    origin: 'https://storage.googleapis.com/sayido-assets-production/',
    cdn: 'https://sayido-assets-production.b-cdn.net/',
  },
  resources: {
    origin: 'https://storage.googleapis.com/sayido-user-production/',
    cdn: 'https://sayido-user-resources.b-cdn.net/',
  },
  legacy: {
    origin: 'https://amazonaws.com/',
    cdn: 'https://sayido-legacy.b-cdn.net/',
  },
};

const isUserUploadedURL = url => url.indexOf(CDN_CONFIG.ugc.origin) > -1;
const isUserResourcesURL = url => url.indexOf(CDN_CONFIG.resources.origin) > -1;
const isAssetsURL = url => url.indexOf(CDN_CONFIG.assets.origin) > -1;
const isHostingURL = url => url.indexOf(CDN_CONFIG.hosting.origin) > -1; // Images uploaded to static website hosting (Firebase hosting as of writing)
const isLegacyURL = url => url.indexOf(CDN_CONFIG.legacy.origin) > -1;

const getOriginType = url => {
  if (isUserUploadedURL(url)) return 'ugc';
  if (isUserResourcesURL(url)) return 'resources';
  if (isAssetsURL(url)) return 'assets';
  if (isHostingURL(url)) return 'hosting';
  if (isLegacyURL(url)) return 'legacy';
  return null;
};

// export const config = CDN_CONFIG; // In case we need to access the origin/cdn values directly

export const generateImageFromCDN = (image, options = {}) => {
  if (!image) {
    return false;
  }
  const PRESETS = {
    'website-desktop-thumbnail': { width: 400, height: 300, fit: 'cover' },
  };

  const defaultOptions = {
    width: 800,
    height: 600,
    fit: 'crop',
  };

  const imageOptions =
    typeof options === 'string' && PRESETS[options]
      ? Object.assign({}, defaultOptions, PRESETS[options])
      : typeof options === 'object'
      ? Object.assign({}, defaultOptions, options)
      : defaultOptions;

  const originType = getOriginType(image);
  const url = image.original || image;
  const IMGOPTIM_OPTIONS = `${imageOptions.width}x${imageOptions.height},${imageOptions.fit},quality=high`;

  // TODO: Properly support non-production CDNs as well
  if (!IS_PROD) {
    return `${url}?IS_PREVIEWING_ORIGINAL_URL_FROM_DEV=true`;
  }

  if (originType === 'ugc') {
    const path = url.split(CDN_CONFIG.ugc.origin)[1];
    const queryStr = Object.keys(imageOptions)
      .map(k => `${k}=${imageOptions[k]}`)
      .join('&');
    return `${CDN_CONFIG.ugc.cdn}${path}?${queryStr}`;
  }

  if (originType === 'resources') {
    return `${url.replace(CDN_CONFIG.resources.origin, CDN_CONFIG.resources.cdn)}`;
  }

  if (originType === 'hosting') {
    return `${url.replace(CDN_CONFIG.hosting.origin, CDN_CONFIG.hosting.cdn)}`;
  }

  if (originType === 'assets') {
    const queryStr = `width=${imageOptions.width}&height=${imageOptions.height}`;
    return `${url.replace(
      CDN_CONFIG.assets.origin,
      CDN_CONFIG.assets.cdn
    )}?${queryStr}`;
  }

  if (originType === 'legacy') {
    const path = url.split(CDN_CONFIG.legacy.origin)[1];
    const queryStr = `width=${imageOptions.width}&height=${imageOptions.height}`;
    return `${CDN_CONFIG.legacy.cdn}${path}?${queryStr}`;
  }

  // Image is _somehow_ using the wrong GCS bucket, so use imageoptim til we can work out how many of these there are and how to get rid of them. I suspect we had the filestack saving to the wrong bucket for a short period of time ¯\_(ツ)_/¯
  return `https://img.gs/kzdlmwpqqk/${IMGOPTIM_OPTIONS}/${url}`;
};
